import { memo } from 'react';

export interface LoadingSpinnerProps {
  readonly size?: 'small' | 'medium' | 'large';
  /** When omitted, only the spinner is shown (callers should pass {@code t(...)} for visible status text). */
  readonly message?: string;
}

export const LoadingSpinner = memo<LoadingSpinnerProps>(({ 
  size = 'medium', 
  message,
}) => {
  const sizeClass = `loading-spinner--${size}`;
  
  return (
    <div className={`loading-spinner ${sizeClass}`} role="status" aria-live="polite">
      <div className="loading-spinner__spinner" />
      {message ? <div className="loading-spinner__message">{message}</div> : null}
    </div>
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';
